import { CategoryImageFormActions } from '../reducer';

export default function takePic(dispatch, refBp3d) {
  return () => {
    const canvas = refBp3d.current?.refContainer?.lastChild;
    const payload = canvas.toDataURL('image/jpeg', 1);
    dispatch({ type: CategoryImageFormActions.SET_IMAGE, payload });
  };
}
